// import Dash from "../../components/Dash/Dash";
// import { csr, FirstImg } from "../../images";
// import "./csr.scss";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper";
// import { Link } from "react-router-dom";
// import useWindowDimensions from "../../hooks/useWindowDimensions";
// import { useGSAP } from "@gsap/react";
// import gsap from "gsap";
// import { useRef } from "react";

// import { ScrollTrigger } from "gsap/ScrollTrigger";
// // ScrollSmoother requires ScrollTrigger
// import { ScrollSmoother } from "gsap/ScrollSmoother";

// gsap.registerPlugin(useGSAP, ScrollTrigger, ScrollSmoother);

// const CSR = () => {
//   const { width } = useWindowDimensions();
//   const wrapperRef = useRef();
//   const contentRef = useRef();
//   const cardRef = useRef();

//   useGSAP(() => {
//     // ScrollSmoother.create({
//     //   wrapper:wrapperRef.current,
//     //   content:contentRef.current,
//     //   smooth:1.2,
//     //   effects:true,
//     //   smoothTouch:0.1,
//     // });

//     const cards = gsap.utils.toArray(".csr_card");

//     console.log(cards);
    
//     gsap.to(wrapperRef.current,{
//       scrollTrigger:{

//       }
//     })

//     cards.forEach((card,i)=>{

//       // gsap.to(card, {
//       //   scrollTrigger: {
//       //     trigger: card,
//       //     start: "top" + (100 * i),
//       //     end: "bottom bottom",
//       //     endTrigger: ".csr_card_holder",
//       //     scrub:true,
//       //     pin:card,
//       //     pinSpacing:false
//       //   },
//       // });

//        gsap.to(card, {
//          scrollTrigger: {
//            trigger: card,
//            start: "top " + 100 * (i + 1),
//            end: "bottom bottom",
//            endTrigger: ".csr_card_holder",
//            scrub: 1,
//             pin: card,
//           //  pin: i !== cards.length - 1,
//            pinSpacing: false,
//           //  markers: true,
//          },
//        });
//     })

//   });



//   const csrData = [
//     {
//       name: "Fire Tender",
//       images: [csr, csr, csr, csr],
//       desc: `In alignment with its CSR focus on community welfare and crisis management, the Company contributed to the procurement of a fully equipped fire tender. This initiative is aimed at strengthening emergency response capabilities in the region surrounding the Company’s factory at Silvassa and Punjab. The fire tender has played a critical role in safeguarding life and property in industrial, residential, and public areas. Through this contribution, the Company aims to enhance employee safety, improve public safety measures, strengthen emergency preparedness within the factory and its surrounding areas, and support development of a more robust and responsive disaster management framework.`,
//     },
//     {
//       name: "Hunger Drive",
//       images: [csr],
//       desc: "The Company focused on eradicating hunger and supporting underprivileged communities. The Company undertook food distribution drives aimed at providing nutritious meals for those in need. These efforts were directed towards marginalized sections of society, including daily wage earners, homeless individuals, and low-income families. Through this initiative, the Company sought to alleviate food insecurity and contribute to the well-being of vulnerable communities.",
//     },
//     {
//       name: "Healthcare",
//       images: [csr],
//       desc: "As part of its CSR initiatives in the healthcare sector, the Company extended support to Masina Hospital by contribution of essential medical equipment. The support included the provision of an ECG machine, ICCU beds, ventilator, infusion pump, syringe pump, MGPS line, and patient monitor. This initiative was undertaken to strengthen the hospital’s critical care capabilities and enhance its overall healthcare infrastructure, thereby contributing to improved medical services for the community.",
//     },
//     {
//       name: "Promote Education",
//       images: [csr],
//       desc: "In alignment with its focus in education, the Company extended infrastructure support to a school with the objective of creating a more conducive learning environment. The assistance included the development and enhancement of basic facilities to improve the overall educational infrastructure. This initiative was aimed at fostering a better academic atmosphere for students and supporting their holistic growth and learning outcomes.",
//     },
//     {
//       name: "Tribute to Veer Naris of the Indian Navy",
//       images: [csr],
//       desc: "As part of its ongoing Corporate Social Responsibility (CSR) initiatives, Sanathan Textiles Limited had undertaken a heartfelt project in support of the Veer Naris of the Indian Navy. This initiative was aimed at providing sustained household support to these courageous women, ensuring financial stability and dignified living conditions until their children are independent and capable of earning a livelihood. This long-term commitment reflects the Company’s deep respect for the sacrifices made by the families of our armed forces and its resolve to contribute meaningfully to their welfare. Accordingly, as part of the CSR tradition, sports equipment’s to Indian Navy associated schools, are given to facilitate sports culture to the extent possible.",
//     },
//     {
//       name: "Environment",
//       images: [csr],
//       desc: 'As part of its environmental sustainability efforts, the Company organized a Plastic-to-Plant Exchange Drive at its Mumbai and Silvassa locations. The initiative community members, referred to as "green champions," exchange a minimum of two hundred grams of plastic waste for a plant, thereby promoting awareness and initiative-taking engagement in responsible waste management. Through this drive, the Company successfully collected five hundred kilograms of plastic waste and distributed 2,500 plants, making a significant contribution towards environmental conservation and fostering community participation.',
//     },
//   ];
//   return (
//     <>
//       <section id="csr_sec1">
//         <div className="wrapper">
//           <div className="breadcrumb_styles">
//             <Link to="/" className="breadcrumb_link">
//               Home
//             </Link>{" "}
//             {">"} ESG
//           </div>
//           <div className="content_wrapper">
//             <div className="left_section">
//               <h1 className="hollow_title ">Corporate Social Responsibility</h1>
//               <div className="dash_wrapper">
//                 <Dash />
//               </div>
//               {/* <h3>Environmental / Social / Governance</h3> */}
//               <p>
//                 We have constituted a corporate and social responsibility
//                 committee and have adopted and implemented a CSR Policy pursuant
//                 to which we carry out CSR activities. In terms of our CSR policy
//                 our CSR expenditure may be towards, amongst others, eradicating
//                 hunger, poverty and malnutrition, promoting health care,
//                 promoting education, promoting gender equality, empowering
//                 women, ensuring environmental sustainability, ecological balance
//                 etc.
//               </p>
//             </div>
//             <figure className="bg_img">
//               <img src={FirstImg} alt="sanathan img" width={726} height={813} />
//             </figure>
//           </div>
//         </div>
//       </section>
//       <section id="csr_sec2">
//         <div className="wrapper">
//           <h2 className="section_head">Corporate Social Responsibility</h2>
//           <p className="section_desc">
//             Aligned with the Company’s core value of Good Corporate Citizenship,
//             your Company actively embraces its social responsibilities through a
//             variety of initiatives aimed at creating a positive impact on
//             society. Guided by the Company’s CSR Policy and its defined focus
//             areas, our efforts were concentrated on critical domains such as
//             eradicating hunger, promoting healthcare, encouraging sports,
//             preserving culture, and protecting the environment. Through
//             well-structured programs, the Company is dedicated to contributing
//             to societal well-being, fostering sustainable development, and
//             supporting social upliftment.
//           </p>
//           <div ref={wrapperRef} className="wrapper">
//             <div ref={contentRef} className="content">
//               <div className="csr_card_holder">
//                 {csrData?.map((e, i) => (
//                   <div ref={cardRef} className="csr_card" key={i}>
//                     <p className="csr_name">
//                       <span>0{i + 1}.</span>
//                       {e.name}
//                     </p>
//                     <div className="card_content">
//                       <div>
//                         <Swiper
//                           loop={true}
//                           modules={[Autoplay]}
//                           autoplay={{
//                             delay: 2500,
//                             disableOnInteraction: false,
//                           }}
//                           slidesPerView={1}
//                           className="mySwiper"
//                         >
//                           {e.images?.map((imgSrc, i) => (
//                             <SwiperSlide key={i}>
//                               <div className="img_wraper">
//                                 <img src={imgSrc} alt="" />
//                               </div>
//                             </SwiperSlide>
//                           ))}
//                         </Swiper>
//                       </div>

//                       <div className="dec">
//                         {width >= 992 ? (
//                           <p className="csr_name">{e.name}</p>
//                         ) : (
//                           <></>
//                         )}
//                         <p className="section_desc">{e.desc}</p>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <div className="spacer"></div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default CSR;

import Dash from "../../components/Dash/Dash";
import {
  csr,
  education1,
  environment1,
  environment2,
  environment3,
  fire1,
  fire2,
  fire3,
  FirstImg,
  healthcare1,
  healthcare2,
  healthcare3,
  healthcare4,
  hunger1,
  hunger2,
  hunger3,
  veer1,
  veer2,
  veer3,
} from "../../images";
import "./csr.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import { Link } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useEffect, useState , useRef } from "react";

import { ScrollTrigger } from "gsap/ScrollTrigger";
// ScrollSmoother requires ScrollTrigger
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(useGSAP, ScrollTrigger, ScrollSmoother);

const CSR = () => {
  const { width } = useWindowDimensions();
  const cardRef = useRef();
  const [headerHeight, setHeaderHeight] = useState(0);

useEffect(() => {
  const header = document.querySelector("header");

  const measure = () => {
    if (header) {
      setHeaderHeight(header.offsetHeight);
    }
  };

  measure();
  window.addEventListener("load", measure);
  return () => window.removeEventListener("load", measure);
}, []);

  // useGSAP(() => {
  //   const cards = gsap.utils.toArray(".csr_card");

  //   // let startValue;
  //   // if (width >= 992) {
  //   //   startValue = "top 136px"; // Desktop
  //   // } else if (width>= 768) {
  //   //   startValue = "top 100px"; // Tablet
  //   // } else {
  //   //   startValue = "top 90px"; // Mobile
  //   // }

  //   if (width >= 992) {
  //     cards.forEach((card, i) => {
  //       gsap.to(card, {
  //         scrollTrigger: {
  //           trigger: card,
  //           start: "top 165px",
  //           end: "bottom 75%",
  //           endTrigger: ".csr_card_holder",
  //           scrub: true,
  //           pin: card,
  //           pinSpacing: false,
  //           markers: true,
  //         },
  //       });
  //     });
  //   } else {
  //     return;
  //   }
  // });

  const csrData = [
    {
      name: "Fire Tender",
      images: [fire1, fire2, fire3],
      desc: `In alignment with its CSR focus on community welfare and crisis management, the Company contributed to the procurement of a fully equipped fire tender. This initiative is aimed at strengthening emergency response capabilities in the region surrounding the Company’s factory at Silvassa and Punjab. The fire tender has played a critical role in safeguarding life and property in industrial, residential, and public areas. Through this contribution, the Company aims to enhance employee safety, improve public safety measures, strengthen emergency preparedness within the factory and its surrounding areas, and support development of a more robust and responsive disaster management framework.`,
    },
    {
      name: "Hunger Drive",
      images: [hunger1, hunger2, hunger3],
      desc: "The Company focused on eradicating hunger and supporting underprivileged communities. The Company undertook food distribution drives aimed at providing nutritious meals for those in need. These efforts were directed towards marginalized sections of society, including daily wage earners, homeless individuals, and low-income families. Through this initiative, the Company sought to alleviate food insecurity and contribute to the well-being of vulnerable communities.",
    },
    {
      name: "Healthcare",
      images: [healthcare1, healthcare2, healthcare3, healthcare4],
      desc: "As part of its CSR initiatives in the healthcare sector, the Company extended support to Masina Hospital by contribution of essential medical equipment. The support included the provision of an ECG machine, ICCU beds, ventilator, infusion pump, syringe pump, MGPS line, and patient monitor. This initiative was undertaken to strengthen the hospital’s critical care capabilities and enhance its overall healthcare infrastructure, thereby contributing to improved medical services for the community.",
    },
    {
      name: "Promote Education",
      images: [education1],
      desc: "In alignment with its focus in education, the Company extended infrastructure support to a school with the objective of creating a more conducive learning environment. The assistance included the development and enhancement of basic facilities to improve the overall educational infrastructure. This initiative was aimed at fostering a better academic atmosphere for students and supporting their holistic growth and learning outcomes.",
    },
    {
      name: "Tribute to Veer Naris of the Indian Navy",
      images: [veer1, veer2],
      desc: "As part of its ongoing Corporate Social Responsibility (CSR) initiatives, Sanathan Textiles Limited had undertaken a heartfelt project in support of the Veer Naris of the Indian Navy. This initiative was aimed at providing sustained household support to these courageous women, ensuring financial stability and dignified living conditions until their children are independent and capable of earning a livelihood. This long-term commitment reflects the Company’s deep respect for the sacrifices made by the families of our armed forces and its resolve to contribute meaningfully to their welfare. Accordingly, as part of the CSR tradition, sports equipment’s to Indian Navy associated schools, are given to facilitate sports culture to the extent possible.",
    },
    {
      name: "Environment",
      images: [environment1, environment2, environment3],
      desc: 'As part of its environmental sustainability efforts, the Company organized a Plastic-to-Plant Exchange Drive at its Mumbai and Silvassa locations. The initiative community members, referred to as "green champions," exchange a minimum of two hundred grams of plastic waste for a plant, thereby promoting awareness and initiative-taking engagement in responsible waste management. Through this drive, the Company successfully collected five hundred kilograms of plastic waste and distributed 2,500 plants, making a significant contribution towards environmental conservation and fostering community participation.',
    },
  ];
  return (
    <>
      <section id="csr_sec1">
        <div className="wrapper">
          <div className="breadcrumb_styles">
            <Link to="/" className="breadcrumb_link">
              Home
            </Link>{" "}
            {">"} ESG
          </div>
          <div className="content_wrapper">
            <div className="left_section">
              <h1 className="hollow_title ">Corporate Social Responsibility</h1>
              <div className="dash_wrapper">
                <Dash />
              </div>
              {/* <h3>Environmental / Social / Governance</h3> */}
              <p>
                We have constituted a corporate and social responsibility
                committee and have adopted and implemented a CSR Policy pursuant
                to which we carry out CSR activities. In terms of our CSR policy
                our CSR expenditure may be towards, amongst others, eradicating
                hunger, poverty and malnutrition, promoting health care,
                promoting education, promoting gender equality, empowering
                women, ensuring environmental sustainability, ecological balance
                etc.
              </p>
            </div>
            <figure className="bg_img">
              <img src={FirstImg} alt="sanathan img" width={726} height={813} />
            </figure>
          </div>
        </div>
      </section>
      <section id="csr_sec2">
        <div className="wrapper">
          <h2 className="section_head">Corporate Social Responsibility</h2>
          <p className="section_desc">
            Aligned with the Company’s core value of Good Corporate Citizenship,
            your Company actively embraces its social responsibilities through a
            variety of initiatives aimed at creating a positive impact on
            society. Guided by the Company’s CSR Policy and its defined focus
            areas, our efforts were concentrated on critical domains such as
            eradicating hunger, promoting healthcare, encouraging sports,
            preserving culture, and protecting the environment. Through
            well-structured programs, the Company is dedicated to contributing
            to societal well-being, fostering sustainable development, and
            supporting social upliftment.
          </p>

          <div className="csr_card_holder">
            {csrData?.map((e, i) => (
              <div
                ref={cardRef}
                className="csr_card"
                key={i}
                style={{ top: `${headerHeight + 20}px` }}
              >
                {width <= 992 ? (
                  <p className="csr_name">
                    <span>0{i + 1}.</span>
                    {e.name}
                  </p>
                ) : (
                  <></>
                )}

                <div className="card_content">
                  <div>
                    <Swiper
                      loop={true}
                      modules={[Autoplay]}
                      autoplay={
                        e.images && e.images.length > 1
                          ? { delay: 2500, disableOnInteraction: false }
                          : false
                      }
                      slidesPerView={1}
                      className="mySwiper"
                    >
                      {e.images?.map((imgSrc, i) => (
                        <SwiperSlide key={i}>
                          <div className="img_wraper">
                            <img src={imgSrc} alt="" />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>

                  <div className="dec">
                    {width >= 992 ? (
                      <p className="csr_name">
                        {" "}
                        <span>0{i + 1}.</span>
                        {e.name}
                      </p>
                    ) : (
                      <></>
                    )}
                    <p className="section_desc">{e.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default CSR;

